import { Component } from '../Component'
import { element } from '../CustomElement'

@element('flipp-loading-spinner')
export class LoadingSpinner extends Component<any, any> {
    render() {
        return (
            <section ref="spinner" class="main">
                <div class="loading">
                    <div class="spinner"></div>
                </div>
            </section>
        )
    }
}
